import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TProductCart, TAccountProductCartPayloadRequest, TProductCartResponse, adaptProductCartFromResponse, adaptAccountProductCartToRequest } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ACCOUNT_PRODUCT_CART } from '../../backend-paths';


export const accountProductCartCreateApi = createAsyncThunk(
	`POST/${BACKEND_ACCOUNT_PRODUCT_CART}`,
	(payload: TAccountProductCartPayloadRequest, thunkApi) => {
		const dataRequest = adaptAccountProductCartToRequest(payload);

		return HttpService.post<TProductCartResponse>(BACKEND_ACCOUNT_PRODUCT_CART, dataRequest).then(result => {
			return adaptProductCartFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TProductCart> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const accountProductCartCreateSlice = createSlice({
	name: 'accountProductCartCreateSlice',
	initialState,
	reducers: {
		clearAccountProductCartCreate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[accountProductCartCreateApi.pending.type]: (state) => {
			state.error = undefined;
			state.isLoading = true;
		},

		[accountProductCartCreateApi.fulfilled.type]: (state, action: PayloadAction<TProductCart>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[accountProductCartCreateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.error = action.payload;
			state.isLoading = false;
		},
	},
});

export const useAccountProductCartCreateSelector = () => useAppSelector(state => state[accountProductCartCreateSlice.name]);

export const { clearAccountProductCartCreate } = accountProductCartCreateSlice.actions;
